import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=50c5cc24&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=50c5cc24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5cc24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c5cc24')) {
      api.createRecord('50c5cc24', component.options)
    } else {
      api.reload('50c5cc24', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=50c5cc24&scoped=true", function () {
      api.rerender('50c5cc24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/marketingEvents/component/upload.vue"
export default component.exports